export const QueryKeys = {
  USER_TYPE_LIST: "userTypeList",
  LMS_TOKEN: "lmsToken",
  GET_PRE_ASSESSMENT_QUESTION: "getPreAssessmentQuestion",
  COURSES_TYPE_LIST: "courses",
  MODULE_TYPE_LIST: "moduleTypeList",
  GET_POST_ASSESSMENT_QUESTION: "getPostAssessmentQuestion",
  GET_POST_CHAPTER_QUESTION: "getPostChapterAssessmentQuestion",
  GET_POST_MODULE_QUESTION: "getPostModuleAssessmentQuestion",
  GET_CHAPTER_BY_MODULE: "getChapterByModule",
  GET_INCLUSIVE_EDUCATION_CONTENT: "getInclusiveEducationContent",
  GET_FEEDBACK_QUESTIONS_INCLUSIVE_EDUCATION:
    "getFeedbackQuestionsInclusiveEducation",
  GET_POST_MODULE_FEEDBACK_FORM: "getPostModuleFeedbackForm",
  CERTIFICATE_KEYS:'certificateKeys',
  TRANSLATION:"translation",
  FINAL_ASSESSMENT_KEYS:'finalAssessment',
  FINAL_ASSESSMENT_QUESTION:'finalAssessmentQuestion'
};
